import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function FeaturedUpdate() {
  return <section className="py-20 md:py-28 px-4 md:px-8" data-id="element-188">
      <div className="max-w-[1400px] mx-auto" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="grid grid-cols-1 lg:grid-cols-5 gap-0 bg-forest text-bone overflow-hidden" data-id="element-190">
          <div className="lg:col-span-3 relative min-h-[320px] lg:min-h-[520px] overflow-hidden group" data-id="element-191">
            <img src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&q=80" alt="Líderes y lideresas en formación geográfica" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-192" />
            <div className="absolute top-6 left-6 bg-clay text-bone px-4 py-2 text-xs font-bold uppercase tracking-widest flex items-center gap-2" data-id="element-193">
              <Sparkles size={14} data-id="element-194" />
              El proyecto en una mirada
            </div>
          </div>

          <div className="lg:col-span-2 p-8 md:p-12 lg:p-14 flex flex-col justify-center" data-id="element-195">
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-[1.1] mb-6" data-id="element-196">
              Información geográfica al servicio de los territorios y las
              comunidades
            </h2>
            <p className="text-bone/80 font-light leading-relaxed mb-4" data-id="element-197">
              El Proyecto TEFOS articula el ordenamiento del territorio, el
              catastro multipropósito, la educación intercultural, los acuerdos
              de conservación y la apropiación de la información geográfica para
              fortalecer la gobernanza ambiental en Colombia.
            </p>
            <p className="text-bone/70 font-light leading-relaxed text-sm" data-id="element-198">
              Recorre esta página para conocer los Objetos Territoriales Legales
              y su visor, la Escuela Intercultural de Geografía, los acuerdos
              con Parques Nacionales en el PNN Paramillo, la plataforma Colombia
              en Mapas y los diplomados virtuales que impulsan este esfuerzo
              colectivo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}